import type { Match } from 'found';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { fetchCollections } from '../actions/collections.actions';
import type { AsyncActionStatus } from '../actions/common.actionTypes';
import MyCollections from '../components/MyCollections';
import withAsyncData from '../components/utils/withAsyncData';
import type { StoreType } from '../reducers';
import { selectOwnCollectionStatus, selectOwnCollections } from '../reducers/collections.selectors';
import type { CollectionProperties } from '../types/AppContent';

interface StateProps {
	collections: CollectionProperties[];
	collectionsStatus: AsyncActionStatus;
}

type OwnListPageProps = Match & StateProps;

const OwnCollectionListPage: React.FC<OwnListPageProps> = ({
	collections,
	collectionsStatus: collectionStatus,
}) => {
	return <MyCollections collectionsStatus={collectionStatus} collections={collections} />;
};

const mapState = (state: StoreType): StateProps => ({
	collections: selectOwnCollections(state),
	collectionsStatus: selectOwnCollectionStatus(state),
});

export default compose<React.FC<Record<string, never>>>(
	connect(mapState, { fetchCollections }),
	withAsyncData((props) => ({
		refetch: () => props.fetchCollections(),
		dataProp: 'collections',
		statusProp: 'collectionsStatus',
	}))
)(OwnCollectionListPage);
